import { AgentClient } from '~/agents/common/client/agent'
import { ReceptionistCommon } from '../common'

export const ReceptionistAgentClient: AgentClient = {
  key: ReceptionistCommon.Agent.key,
  getTabs: () => [],
}
